module.exports = __webpack_public_path__ + "static/media/SERIED-01.e4285c98.png";